module.exports = __webpack_public_path__ + "static/pdf/film_scripts-3BB.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/film_scripts-3BB.pdf
// module id = 207
// module chunks = 0